import React, { useEffect, useState } from 'react';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { useDispatch } from 'react-redux';
import { useToast } from 'context/tostifyContext';

const notificationIcon = <NotificationsActiveIcon style={{ color: '#ffffff' }} />;

const useNotifications = () => {
  const [notificationPageData, setNotificationPageData] = useState([]);
  const { showToast } = useToast();

  const [openNotificationForm, setOpenNotificationForm] = useState(false);
  const [openNotificationType, setOpenNotificationType] = useState(null); // 'site' | 'contract'
  const handleOpenSiteNotification = () => {
    setOpenNotificationType('site');
    setOpenNotificationForm(true); // 👈 open the dialog here
  };

  const handleOpenContractNotification = () => {
    setOpenNotificationType('contract');
    setOpenNotificationForm(true); // 👈 open the dialog here too
  };
  const handleCloseNotificationDialog = () => {
    setOpenNotificationForm(false);
    setOpenNotificationType(null);
  };
  const handleOpenNotificationClick = () => {
    setOpenNotificationForm(true);
  };

  useEffect(() => {
    const data = [
      {
        id: 1,
        cardTitle: 'Site Assesment Notifications',
        cardValue: null,
        cardHref: '/',
        icon: notificationIcon,
        backgroundColor: '#2196f3',
        onClick: handleOpenSiteNotification,
      },
      {
        id: 2,
        cardTitle: 'Contract Notification',
        cardValue: null,
        cardHref: '/',
        icon: notificationIcon,
        backgroundColor: '#2196f3',
        onClick: handleOpenContractNotification,
      },
    ];
    setNotificationPageData(data);
  }, []);

  const handleNotificationSubmit = () => {
    setOpenNotificationForm(false);
    showToast('Notification Submitted Successfully', 'success');
  };

  return {
    notificationPageData,
    openNotificationForm,
    setOpenNotificationForm,
    handleNotificationSubmit,
    openNotificationType,
    handleCloseNotificationDialog,
  };
};

export default useNotifications;
